import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { appConfig } from './config/app-config';
const language = window.sessionStorage.getItem('language') || 'en';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'es-MX', 'es-US'],
    fallbackLng: 'en',
    lng: language,
    detection: {
      order: [
        'path',
        'cookie',
        'htmlTag',
        'localStorage',
        'sessionStorage',
        'navigator',
        'querystring',
        'subdomain',
      ],
      caches: ['cookie'],
    },
    backend: {
      loadPath: `${appConfig.microUrl}/digiorderform/Translation/{{lng}}/{{ns}}.json`,
    },
    ns: ['dof'],
    defaultNS: 'dof',
    react: {
      useSuspense: false,
    },
  });

export default i18n;
